import { AppConfigurationContext } from '#app/contexts/AppConfigurationContext/AppConfigurationContext.js';
import { useContext } from 'react';

export const useAppConfiguration = () => {
  const appConfiguration = useContext(AppConfigurationContext);

  if (appConfiguration === null) {
    throw new Error(
      'Cannot use useAppConfiguration outside of AppConfigurationContext',
    );
  }

  return appConfiguration;
};
